import React, { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import {
  BsCheckCircleFill,
  BsExclamationCircleFill,
  BsInfoCircleFill,
  BsExclamationTriangleFill,
} from "react-icons/bs";
import { registerAlertHandler } from "../../utils/alertService";
import "./GlobalAlert.css"; // <-- new CSS file

const typeConfig = {
  success: {
    variant: "success",
    icon: <BsCheckCircleFill className="me-2 text-success" />,
  },
  danger: {
    variant: "danger",
    icon: <BsExclamationCircleFill className="me-2 text-danger" />,
  },
  warning: {
    variant: "warning",
    icon: <BsExclamationTriangleFill className="me-2 text-warning" />,
  },
  info: {
    variant: "info",
    icon: <BsInfoCircleFill className="me-2 text-info" />,
  },
};

const GlobalAlert = () => {
  const [alert, setAlert] = useState(null);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    registerAlertHandler((config) => {
      const {
        type = "info",
        title,
        message,
        duration = 3000,
      } = config || {};

      const newAlert = {
        id: Date.now(),
        type,
        title,
        message,
        duration,
      };

      setAlert(newAlert);

      // Trigger entry animation
      setTimeout(() => setAnimate(true), 10);
    });
  }, []);

  useEffect(() => {
    if (!alert) return;

    const timer = setTimeout(() => {
      handleClose();
    }, alert.duration);

    return () => clearTimeout(timer);
  }, [alert]);

  const handleClose = () => {
    setAnimate(false); // start exit animation

    setTimeout(() => {
      setAlert(null);
    }, 250); // matches fade-out duration
  };

  if (!alert) return null;

  const cfg = typeConfig[alert.type] || typeConfig.info;

  return (
    <div
      className={`global-alert-wrapper position-fixed top-0 end-0 p-3 ${
        animate ? "alert-in" : "alert-out"
      }`}
      style={{ zIndex: 2000 }}
    >
      <Alert
        variant={cfg.variant}
        dismissible
        onClose={handleClose}
        className="d-flex align-items-start shadow global-alert-box"
      >
        <div className="me-2 mt-1 fs-5">{cfg.icon}</div>
        <div>
          {alert.title && <div className="fw-bold mb-1">{alert.title}</div>}
          {alert.message && <div>{alert.message}</div>}
        </div>
      </Alert>
    </div>
  );
};

export default GlobalAlert;
